import { getLanguageCode } from '../utilities';

export default class OrderClient
{
    constructor()
    {
        let languageCode = getLanguageCode();

        this._uri = '/api-orderlist-' + languageCode;
        this._dataSrc = 'orderLists';
    }

    get uri()
    {
        return this._uri;
    }

    get dataSrc()
    {
        return this._dataSrc;
    }

    /**
	 * GET
	 */

    /**
	 * @param orderId
	 * @returns {Promise<Response>}
	 */
    fetchAllItems(orderId)
    {
        return fetch(this._uri + '/' + orderId + '/items/all');
    }

    /**
	 * @param orderId
	 * @returns {Promise<Response>}
	 */
    fetchOrder(orderId)
    {
        return fetch(this._uri + '/' + orderId);
    }

    /**
	 * @param orderId
	 * @param offset
	 * @param limit
	 * @returns {Promise<Response>}
	 */
    fetchItems(orderId, offset, limit)
    {
        return fetch(this._uri + '/' + orderId + '/items', {
            headers: {
                'Content-Type': 'application/json'
            },
            body: {
                'skip': offset,
                'take': limit
            }
        });
    }

    /**
	 * PUT
	 */

    /**
	 * @param orderId
	 * @returns {Promise<Response>}
	 */
    addToCart(orderId)
    {
        return fetch(this._uri + '/' + orderId + '/add-to-cart', {
            method: 'PUT',
            credentials: 'include',
        });
    }

    /**
	 * @param orderId
	 * @returns {Promise<Response>}
	 */
    replaceCart(orderId)
    {
        return fetch(this._uri + '/' + orderId + '/replace-cart', {
            method: 'PUT',
            credentials: 'include',
        });
    }

    /**
	* DELETE
	*/

    cancelOrder(orderId)
    {
        return fetch(this._uri + '/' + orderId, {
            method: 'DELETE'
        });
    }
}
